import React, { useState } from "react";
import "../styles/CaesarСipherhelppanel.css";
import { useGame } from "../GameContext";

type HelppanelProps = {
  type: string;
};
const Helppanel: React.FC<HelppanelProps> = ({ type }) => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="CaesarСipher-helpPanel" id="CaesarСipher-helpPanel">
      <img
        src="/img/close.svg"
        id="CaesarСipher-closeButton"
        alt="Закрыть"
        className="CaesarСipher-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="CaesarСipher-helpPivots">
        <div
          className="CaesarСipher-selectPivots"
          id={showhelpPivots === "pivotTask" ? "CaesarСipher-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="CaesarСipher-commandsCards">
          <div className="CaesarСipher-helpCard">
            <div className="CaesarСipher-cardCaption">Суть игры</div>
            {(() => {
              switch (type) {
                case "1":
                  // Здесь можно добавить текст для типа 1
                  return <div>Content for type1</div>;
                case "2":
                  // Здесь можно добавить текст для типа 2
                  return <div>Content for type2</div>;
              }
            })()}
          </div>
          <div className="CaesarСipher-helpCard">
            <div className="CaesarСipher-cardCaption">Правила игры</div>
             {(() => {
                switch (type) {
                  case "1":
                    // Здесь можно добавить текст для типа 1
                    return <div>Content for type1</div>;
                  case "2":
                    // Здесь можно добавить текст для типа 2
                    return <div>Content for type2</div>;
                }
              })()}
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
